import React from 'react';
import { variables } from 'src/Tenants';
import Table from '../../Table';
import Loader from '../../Loader';
import Search from 'src/components/Search/Search';
import './inbox-suites-list.scss';

const InboxSuitesList = ({
  inboxList,
  onStartNewThread,
  suitesList,
  loadingSuites,
  searchString,
  onSearch,
  onSelectItem,
}) => {
  const onSelectedItem = async (data) => {
    const params = {
      id: data.id,
      referenceId: data.id,
      referenceType: 'Suite',
      description: data.stratalot,
      ticketNumber: data.number,
      message: '',
      suiteName: data.number,
      propertyName: data.propertyName,
      propertyId: data.propertyId,
      isNew: true,
    };

    const existingThread = (inboxList || []).find(
      (item: any) => item.referenceId === data.id
    );

    if (existingThread && existingThread.id) {
      onSelectItem({ ...params, id: existingThread.id });
      return;
    }

    onStartNewThread(params);
    onSelectItem(params);
  };

  return (
    <div className="inbox-suites-list">
      <div className="suites-panel">
        {loadingSuites && <Loader center={true} />}
        <div className="search-box">
          <Search
            value={searchString}
            placeholder={`Search ${variables.suiteName}...`}
            onChange={onSearch}
            size={undefined}
            theme={undefined}
          />
        </div>
        <div className="suites-table-scroll">
          {suitesList && suitesList.length > 0 && (
            <Table
              columns={[
                {
                  label: variables.Suite,
                  sortable: true,
                  accessor: 'name',
                  cell: (data) => (
                    <div
                      className="suite-link"
                      onClick={() => onSelectedItem(data)}
                    >
                      {data && data.number}
                    </div>
                  ),
                },
                {
                  label: variables.homeOwner,
                  cell: (data) =>
                    data.homeOwners && data.homeOwners.id ? (
                      <>
                        {data.homeOwners.firstname +
                          ' ' +
                          data.homeOwners.lastname}
                      </>
                    ) : null,
                },
                {
                  center: true,
                  xsHide: true,
                  label: 'Status',
                  accessor: 'status',
                },
              ]}
              data={suitesList}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default InboxSuitesList;